//
// Component
//

export function initialiseForumTopicReplySummary(forumTopicReplySummary: HTMLElement)
{
	forumTopicReplySummary.addEventListener("click", 
		(event) =>
		{
			const eventTarget = event.target as HTMLElement;

			if (eventTarget.closest("a") != null)
			{
				// if the click was on an anchor, let the browser handle it
				return;
			}

			const href = forumTopicReplySummary.dataset["href"];
			const target = forumTopicReplySummary.dataset["target"];

			// navigate to href either in current tab or new tab depending on target
			window.open(href, target);
		});

	forumTopicReplySummary.classList.add("initialised");
}

export function initialiseForumTopicReplySummaries()
{
	const forumTopicReplySummaries = document.querySelectorAll<HTMLElement>(".component-forum-topic-reply-summary:not(.initialised)");

	console.log("[ForumTopicReplySummary] Initialising " + forumTopicReplySummaries.length + " instances...");

	for (const forumTopicReplySummary of forumTopicReplySummaries)
	{
		try
		{
			initialiseForumTopicReplySummary(forumTopicReplySummary);
		}
		catch (error)
		{
			console.error("[ForumTopicReplySummary] Error initialising:", forumTopicReplySummary, error);
		}
	}
}